
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexE6Mi12Sw7qsIEOBRJB_Otec8Fbev8OS9Yan8Q67SN_EMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/index.vue?macro=true";
import { default as about_45usr_45_yj7Q7Ww0jDbdf0DVBIaalEzS9pO7QkDUYYVoStk8Meta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/about-us.vue?macro=true";
import { default as productsrQQ_gQIdZWsmpEpwl1qeCxUBi4lpm4tWmVBYUEbGgqEMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/products.vue?macro=true";
import { default as indexmuRPmmDIcMtzj4Q4cF7JoVFm_bGzNccsuy4YF140E5gMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/sds/index.vue?macro=true";
import { default as indexMpYIiPZMbGrY_Uc59zdbxZ3vw9Aarid__fEANBeWvmgMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/blog/index.vue?macro=true";
import { default as contact_45usGthpFN_45W9FwB_45qwpBOD07_gnAKjk4CEYDVNXpsgctRoMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/contact-us.vue?macro=true";
import { default as industriesbrgwdDW9ibnegy5KyyXV4O65tAOqSZMtBWbZHwMMkvYMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/industries.vue?macro=true";
import { default as _91slug_93otRtIzqv_45uMwCLWtRtiFvFLWmSgaxErQ16ypXk_45pvRIMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/sds/[slug].vue?macro=true";
import { default as _91slug_931fFrU5J_45zZWlYJFUmsa15QuWwtKi3PVFq3TQ_M3kVqcMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/blog/[slug].vue?macro=true";
import { default as our_45servicecNWYXqWmCLZVZJuUC0yl2eaEy636_4JMmT1e_45qHTKuQMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/our-service.vue?macro=true";
import { default as applicationsSByD4hHFeOr7mbtxBGNlSisVO4jPlTobgOjcfq3RT8oMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/applications.vue?macro=true";
import { default as _91slug_93buzk2kKyFybTQI4qIoFM5RDS9IrXvDwxsaGn_45Rd7qxsMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/product/[slug].vue?macro=true";
import { default as _91slug_93LGuGLM7GVEgDml7F9TX9Cqgra2hQaQKfAPzeSXk3058Meta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/industry/[slug].vue?macro=true";
import { default as _91slug_93H4W0xTfOFfIfwD_pcbw7cpQq6qUYSPoLQRBBKQb1lbwMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/application/[slug].vue?macro=true";
import { default as custom_45solutionswH9ijcnAKKIlYS_451_Qx0eFA46UOx1nlTVicRrMv5w4AMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/custom-solutions.vue?macro=true";
import { default as ethanol_45blendingPEDnF1zS9J8pETiEGSYiE4iTI68kQxvNU6IgtTs20mQMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/ethanol-blending.vue?macro=true";
import { default as essential_45chemicalsfdVt_dwxDB_45u6XPnvN0irbnJAuyYYEmEFTxd0sQ86dYMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/essential-chemicals.vue?macro=true";
import { default as manufactured_45productsq4g1nNkupOBcKV5ks4vSZsnlcmxkOeB1tbk_Eh0NgrUMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/manufactured-products.vue?macro=true";
import { default as hazardous_45waste_45solutions0qBFtZJufOUNdrHrn6jMvHT9WVmb7S4LzyV2AdwcUksMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/hazardous-waste-solutions.vue?macro=true";
import { default as manufacturing_45as_45a_45serviceChPltMyPX3hOuW4Sh8QOEEKxx3b3kBCufmX4RkUMP1UMeta } from "/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/manufacturing-as-a-service.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/index.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/about-us.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/products.vue")
  },
  {
    name: "sds",
    path: "/sds",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/sds/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/blog/index.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/contact-us.vue")
  },
  {
    name: "industries",
    path: "/industries",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/industries.vue")
  },
  {
    name: "sds-slug",
    path: "/sds/:slug()",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/sds/[slug].vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: {"middleware":["bloghero-server"]},
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/blog/[slug].vue")
  },
  {
    name: "our-service",
    path: "/our-service",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/our-service.vue")
  },
  {
    name: "applications",
    path: "/applications",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/applications.vue")
  },
  {
    name: "product-slug",
    path: "/product/:slug()",
    meta: { ...(_91slug_93buzk2kKyFybTQI4qIoFM5RDS9IrXvDwxsaGn_45Rd7qxsMeta || {}), ...{"middleware":["producthero-server"]} },
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/product/[slug].vue")
  },
  {
    name: "industry-slug",
    path: "/industry/:slug()",
    meta: { ...(_91slug_93LGuGLM7GVEgDml7F9TX9Cqgra2hQaQKfAPzeSXk3058Meta || {}), ...{"middleware":["industryhero-server"]} },
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/industry/[slug].vue")
  },
  {
    name: "application-slug",
    path: "/application/:slug()",
    meta: { ...(_91slug_93H4W0xTfOFfIfwD_pcbw7cpQq6qUYSPoLQRBBKQb1lbwMeta || {}), ...{"middleware":["applicationhero-server"]} },
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/application/[slug].vue")
  },
  {
    name: "solutions-custom-solutions",
    path: "/solutions/custom-solutions",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/custom-solutions.vue")
  },
  {
    name: "solutions-ethanol-blending",
    path: "/solutions/ethanol-blending",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/ethanol-blending.vue")
  },
  {
    name: "solutions-essential-chemicals",
    path: "/solutions/essential-chemicals",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/essential-chemicals.vue")
  },
  {
    name: "solutions-manufactured-products",
    path: "/solutions/manufactured-products",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/manufactured-products.vue")
  },
  {
    name: "solutions-hazardous-waste-solutions",
    path: "/solutions/hazardous-waste-solutions",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/hazardous-waste-solutions.vue")
  },
  {
    name: "solutions-manufacturing-as-a-service",
    path: "/solutions/manufacturing-as-a-service",
    component: () => import("/Users/michaelpeters/Dev/iSolvents/iSolventsEssential/isolvents-io-ess/app/pages/solutions/manufacturing-as-a-service.vue")
  }
]